<div (click)="show()" class="info">
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9992 8.78581C12.9197 8.78581 13.6659 8.03961 13.6659 7.11914C13.6659 6.19867 12.9197 5.45247 11.9992 5.45247C11.0788 5.45247 10.3326 6.19867 10.3326 7.11914C10.3326 8.03961 11.0788 8.78581 11.9992 8.78581Z"
      fill="#079BD1" />
    <path
      d="M13.388 11.6867V17.18C13.388 17.5478 13.2419 17.9005 12.9819 18.1605C12.7218 18.4206 12.3691 18.5667 12.0014 18.5667C11.6336 18.5667 11.2809 18.4206 11.0208 18.1605C10.7608 17.9005 10.6147 17.5478 10.6147 17.18V11.6867C10.6147 11.3189 10.7608 10.9662 11.0208 10.7062C11.2809 10.4461 11.6336 10.3 12.0014 10.3C12.3691 10.3 12.7218 10.4461 12.9819 10.7062C13.2419 10.9662 13.388 11.3189 13.388 11.6867Z"
      fill="#079BD1" />
    <path
      d="M12 0C5.3728 0 0 5.3728 0 12C0 18.6272 5.3728 24 12 24C18.6272 24 24 18.6272 24 12C24 5.3728 18.6272 0 12 0ZM18.9765 18.9765C18.0632 19.9056 16.9749 20.6445 15.7745 21.1508C14.5741 21.657 13.2854 21.9205 11.9826 21.9261C10.6798 21.9316 9.38882 21.6791 8.18415 21.1831C6.97947 20.6871 5.88494 19.9575 4.96373 19.0363C4.04252 18.1151 3.31287 17.0205 2.81688 15.8159C2.32089 14.6112 2.06839 13.3202 2.07394 12.0174C2.07949 10.7146 2.34299 9.42587 2.84924 8.22546C3.35548 7.02505 4.09444 5.93679 5.02347 5.02347C5.93679 4.09444 7.02505 3.35548 8.22546 2.84924C9.42587 2.34299 10.7146 2.07949 12.0174 2.07394C13.3202 2.06839 14.6112 2.32089 15.8159 2.81688C17.0205 3.31287 18.1151 4.04252 19.0363 4.96373C19.9575 5.88494 20.6871 6.97947 21.1831 8.18415C21.6791 9.38882 21.9316 10.6798 21.9261 11.9826C21.9205 13.2854 21.657 14.5741 21.1508 15.7745C20.6445 16.9749 19.9056 18.0632 18.9765 18.9765Z"
      fill="#079BD1" />
    <path
      d="M12 0C5.3728 0 0 5.3728 0 12C0 18.6272 5.3728 24 12 24C18.6272 24 24 18.6272 24 12C24 5.3728 18.6272 0 12 0ZM18.9765 18.9765C18.0632 19.9056 16.9749 20.6445 15.7745 21.1508C14.5741 21.657 13.2854 21.9205 11.9826 21.9261C10.6798 21.9316 9.38882 21.6791 8.18415 21.1831C6.97947 20.6871 5.88494 19.9575 4.96373 19.0363C4.04252 18.1151 3.31287 17.0205 2.81688 15.8159C2.32089 14.6112 2.06839 13.3202 2.07394 12.0174C2.07949 10.7146 2.34299 9.42587 2.84924 8.22546C3.35548 7.02505 4.09444 5.93679 5.02347 5.02347C5.93679 4.09444 7.02505 3.35548 8.22546 2.84924C9.42587 2.34299 10.7146 2.07949 12.0174 2.07394C13.3202 2.06839 14.6112 2.32089 15.8159 2.81688C17.0205 3.31287 18.1151 4.04252 19.0363 4.96373C19.9575 5.88494 20.6871 6.97947 21.1831 8.18415C21.6791 9.38882 21.9316 10.6798 21.9261 11.9826C21.9205 13.2854 21.657 14.5741 21.1508 15.7745C20.6445 16.9749 19.9056 18.0632 18.9765 18.9765Z"
      fill="#079BD1" />
  </svg>
</div>

<div [class.visible]="info.visible$ | async" class="information">
  <div class="information-header">
    <inka-back (back)="back()" class="information-header-back"></inka-back>
    <h3 class="information-header-title">
      {{'info.' + id + '.header' | translate}}
    </h3>
  </div>

  <div class="information-content">

    <ng-container [ngSwitch]="type">
      <div *ngSwitchCase="'game'" class="options">
        <h4>
          {{'info.label.types' | translate}}
        </h4>
        <div class="answer">
          {{'info.' + id + '.type' | translate}}
        </div>
      </div>

      <div *ngSwitchCase="'goal'" class="options">
        <h4>
          {{'info.label.goals' | translate}}
        </h4>
        <div class="answer">
          {{'info.' + id + '.goal' | translate}}
        </div>
      </div>
    </ng-container>

    <ng-container [ngSwitch]="item">
      <h4 *ngSwitchCase="'common'">
        {{'header.rules' | translate}}
      </h4>
      <h4 *ngSwitchCase="'rule'">
        {{'info.label.rules' | translate}}
      </h4>
      <h4 *ngSwitchCase="'instruction'">
        {{'info.label.instructions' | translate}}
      </h4>
    </ng-container>

    <ng-container *ngIf="item">
      <p *ngFor="let item of list">
        {{'info.' + id + '.' + item | translate}}
      </p>
    </ng-container>

    <div *ngIf="option" class="options">
      <h4>
        {{'info.label.options' | translate}}
      </h4>
      <div class="answer">
        {{'info.' + id + '.option' | translate}}
      </div>
    </div>
  </div>

  <div class="information-space"></div>

  <div class="information-actions">
    <div class="information-actions-checkbox">
      <input (ngModelChange)="dontShow = !dontShow" [(ngModel)]="dontShow" id="showAgain" type="checkbox">

      <label for="showAgain">
        <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <rect *ngIf="!dontShow" fill="#FFFFFF" height="22" rx="3" stroke="#E1E8E8" stroke-width="2" width="22" x="1"
            y="1" />
          <rect *ngIf="dontShow" fill="#079BD1" height="24" rx="4" width="24" />
          <path *ngIf="dontShow"
            d="M17.9962 8.26472C17.9759 8.04868 17.876 7.85376 17.7145 7.71569L16.5088 6.68422C16.1763 6.39996 15.6839 6.45031 15.4107 6.7963L10.3405 13.2182L8.30366 11.4014C7.97667 11.1114 7.48346 11.1496 7.20329 11.4899L6.188 12.7236C6.05221 12.8876 5.98665 13.098 6.00226 13.314C6.01787 13.5301 6.11464 13.7274 6.27228 13.8688L10.1243 17.3043C10.2671 17.4318 10.4451 17.5 10.6308 17.5C10.6542 17.5 10.6768 17.4992 10.7003 17.4968C10.911 17.4773 11.1006 17.3733 11.2348 17.2036L17.823 8.85923C17.9548 8.69192 18.0165 8.47994 17.9962 8.26472V8.26472Z"
            fill="white" />
        </svg>
        <span class="text">
          {{'info.button.again' | translate}}
        </span>
      </label>
    </div>

    <button (click)="next()" class="information-actions-next">
      {{'info.button.next' | translate}}
    </button>
  </div>
</div>